<template>
    <div class="published-course-disclaimer">
        <div class="published-course-disclaimer__box">
          <div class="published-course-disclaimer__box__icon">
            <i class="material-icons">info</i>
          </div>
          <div class="published-course-disclaimer__box__text">
            <h3>{{ $t('disclaimer.EDITING_PUBLISHED_COURSE') }}</h3>
            <p>{{ $t('disclaimer.ONLY_SOME_FIELDS_EDITABLE') }}</p>
            <p>{{ $t('disclaimer.MODIFICATIONS_WILL_IMPACT_ASSOCIATED_COURSES') }}</p>
          </div>
        </div>
      </div>
</template>

<script>
import { onMounted, onUnmounted } from 'vue';


export default {
    name: 'Disclaimer',
    setup() {

        const handleScroll = () => {
            const elementContainer = document.querySelector('.published-course-disclaimer');
            const element = document.querySelector('.published-course-disclaimer__box');
            if (!element) return;

            const containerPosition = elementContainer.getBoundingClientRect().top;
            // const position = element.getBoundingClientRect().top;
            if (containerPosition < -100  ) {
                element.classList.add('fixed');
            } else {
                element.classList.remove('fixed');
            }
        };

        onMounted(() => {
            window.addEventListener('scroll', handleScroll);
        });

        onUnmounted(() => {
            window.removeEventListener('scroll', handleScroll);
        });
    }
}
</script>




<style lang="scss" scoped>
@import '@/styles/main.scss';

.published-course-disclaimer {
    margin: 20px auto;
    height: 130px;
    z-index: 1;
    width: 100%;
    max-width: 1000px;
    .published-course-disclaimer__box {
        display: flex;
        padding: 20px;
        border-radius: 10px;
        background-color: #FDEAC7;
        gap: 20px;
        // position: fixed;
        // right: 0;
        // left: 0;
        // width: calc(100vw - 24px);
        // max-width: 1000px;
        // margin: 0 auto;
        // position: sticky;

        &.fixed {
            position: fixed;
            // top: 30px; // Final position of the animation
            right: 0;
            left: 0;
            width: calc(100vw - 24px);
            max-width: 1000px;
            margin: 0 auto;
            animation: slideDown 0.5s ease-in-out forwards;
        }
      .published-course-disclaimer__box__icon {
        i {
          font-size: 40px;
          color: #f5a623;
        }
      }
      .published-course-disclaimer__box__text {
        h3 {
          font-size: 18px;
          margin-bottom: 10px;
          color: #F7B844;
        }
        p {
          font-size: 14px;
          color: #212121;

          @media(max-width:980px) {
            font-size: 11px;
          }
        }
      }
    }
  }

  @keyframes slideDown {
    from {
        top: -500px;
    }
    to {
        top: 80px;
    }
}
</style>
